<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <!-- <graph-submenu :position="graphPosition" /> -->
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
            <graph-button @modeSwitch="isNumber = !isNumber" />
            <graph-switch :text="switchTo" @switchGraph="switchMode" />
        </div>
        <div v-show="isNumber" class="uk-margin-medium-left">
            <span class="uk-text-small">{{ title }}</span
            ><br />
            <span class="uk-margin-auto uk-heading-medium uk-margin-none uk-text-bolder"> {{ timeLocal }} </span><br />
            <span v-if="difference !== 0" class="uk-text-meta">
                <span
                    class="transition-transform"
                    :class="{ 'uk-text-success': difference > 0, 'uk-text-danger': difference < 0 }"
                >
                    <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                        <img
                            :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                            class="transition-transform"
                            :class="{
                                'rotate-90': difference > 0,
                                'uk-fill-danger': difference < 0,
                            }"
                            uk-svg
                        />
                    </i>
                    {{ differenceLocal }}%
                </span>
                change to the previous period
            </span>
            <span v-else class="uk-text-meta">
                <span class="uk-text-warning"> {{ differenceLocal }}% </span> change to the previous period
            </span>
        </div>

        <div v-show="!isNumber" class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ timeLocal }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small margin-left-small"
                :class="{ 'uk-text-danger': difference > 0, 'uk-text-success': difference < 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference > 0,
                            'uk-fill-danger': difference > 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta uk-padding-top-60 uk-position-center-left uk-width">{{ title }}</span>
        </div>

        <bar-part v-if="!isNumber" :chart-data="getChartData" :is-time-y-axis="true" />

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import GraphButton from "./graphParts/GraphButton.vue";
import BarPart from "./graphParts/BarPart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphSwitch from "./graphParts/GraphSwitch.vue";
import GraphSubmenu from "./graphParts/GraphSubmenu.vue";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default GraphsMixin.extend({
    name: "NumberGraph",
    components: { GraphButton, BarPart, GraphSwitch, GraphSubmenu, GraphHelp, GraphModal },
    mixins: [GraphsMixin],
    data() {
        return {
            isNumber: true,
            switchTo: "Average",
            isAverage: true,
        };
    },
    methods: {
        switchMode() {
            this.isAverage = !this.isAverage;

            if (this.isAverage) {
                this.switchTo = "Average";
                this.aggregator = "/average";
            } else {
                this.switchTo = "Median";
                this.aggregator = "/median";
            }

            this.getData(this.$buildURL(this.dataPath + this.aggregator, this.filters));
        },
    },
    computed: {
        timeLocal() {
            const hours = Math.floor(this.aggregatedValue / 3600).toString();
            const minutes = Math.floor((this.aggregatedValue % 3600) / 60).toString();
            const seconds = Math.floor(this.aggregatedValue % 60).toString();

            return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${seconds.padStart(2, "0")}`;
        },
        differenceLocal() {
            this.difference = this.difference * -1;
            return this.$formatNumber(Math.abs(this.difference));
        },
    },
});
</script>
